<app-modal-shell
  [title]="'ADDRESS_DATA.TITLE'"
  [cancelLabel]="'ADDRESS_DATA.BUTTONS.CANCEL'"
  [saveLabel]="'ADDRESS_DATA.BUTTONS.OK'"
  (cancelClicked)="cancel()"
  (saveClicked)="save()">

  <div class="form-group">
    <form [id]="'adressDataForm'" [formGroup]="form">
      <div class="row">
        <div class="col-12">
          <app-custom-input id="street" type="text"
                            [label]="'ADDRESS_DATA.STREET' | translate"
                            [customFormGroup]="form"
                            [noteText]="'ADDRESS_DATA.FIELD_ERROR.REQUIRED' | translate"
                            data-cy="address-data-street"
          ></app-custom-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-custom-input id="addressAddition" type="text"
                            [label]="'ADDRESS_DATA.ADDRESS_ADDITION' | translate"
                            [customFormGroup]="form"
                            [noteText]="'ADDRESS_DATA.FIELD_ERROR.REQUIRED' | translate"
                            data-cy="address-data-address-addition"
          ></app-custom-input>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <app-custom-input id="postalCode" type="text"
                            [label]="'ADDRESS_DATA.POSTALCODE' | translate"
                            [customFormGroup]="form"
                            [noteText]="postalCodeErrorLabel | translate"
                            data-cy="address-data-postal-code"
          ></app-custom-input>
        </div>
        <div class="col-8">
          <app-custom-input id="city" type="text"
                            [label]="'ADDRESS_DATA.CITY' | translate"
                            [customFormGroup]="form"
                            [noteText]="'ADDRESS_DATA.FIELD_ERROR.REQUIRED' | translate"
                            data-cy="address-data-city"
          ></app-custom-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-custom-select
            id="country"
            [class]="'sfk-ellipsed-ng-select'"
            [customFormGroup]="form"
            [items]="landList"
            [multiple]="false"
            [clearable]="false"
            bindLabel="value"
            bindValue="key"
            [label]="'ADDRESS_DATA.COUNTRY' | translate"
            [noteText]="'ADDRESS_DATA.FIELD_ERROR.REQUIRED' | translate"
            (onchange)="setPlzPatternValidator()"
            data-cy="address-data-country"
          ></app-custom-select>
        </div>
      </div>
    </form>
  </div>

</app-modal-shell>
